export default __webpack_public_path__ + "static/Layer_4-4239e32d1b6c1bdb1ba92834cbc9bb04.png";